import { render, staticRenderFns } from "./setAgainDraw.vue?vue&type=template&id=7724c49c&scoped=true&"
import script from "./setAgainDraw.vue?vue&type=script&lang=js&"
export * from "./setAgainDraw.vue?vue&type=script&lang=js&"
import style0 from "./setAgainDraw.vue?vue&type=style&index=0&id=7724c49c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7724c49c",
  null
  
)

export default component.exports